import * as constants from "../assets/constants";

import axios from "axios";

class CartApi {

    base_url = ""
    items = []

    constructor(base_url) {
        this.base_url = base_url
        this.getItems();
    }


    addAdditional = (el) => {
        if (el.additionalItems && Array.isArray(el.additionalItems)) {
            const additional = []

            el.additionalItems.map(additionalItem => additional.push({
                product_id: additionalItem.id,
                name: additionalItem.product ? additionalItem.producto.name : additionalItem.name,
                type: additionalItem.need_ost ? 'number' : 'checkbox',
                comment: additionalItem.comment,
                qnt: additionalItem.need_ost ? additionalItem.qnt : (additionalItem.checked ? 1 : 0)
            }))

            el.additional = additional
        }
    }
    addOrEdit = (item) => {
        if (!item) return;
        if (item.meta_id == undefined) return;
        if (item.sclad_id == undefined) return;
        let next;
        let find = false;
        for (next in this.items) {
            let el = this.items[next]
            if (item.id != undefined && item.id == el.id) {
                this.addAdditional(item)
                this.items[next] = item;
                find = true;
                break;
            }
        }
        if (!find) {
            if (item.quantity == undefined) {
                item.quantity = 1;
            }
            if (item.id == undefined) {
                item.id = constants.getGUID()
            }
            this.addAdditional(item)
            this.items.push(item)

        }


    }

    saveItems = (onSaved = null) => {
        const body = new FormData()

        let sAjaxSource = '/?app=cart&act=saveItems&cart_id=' + this.getCartId()

        body.append('items', JSON.stringify(this.items));
        body.append('guid', this.getCartId());

        axios.post(this.base_url + sAjaxSource, body,
            {
                withCredentials: true


            }
        ).then((response) => {
            if (typeof onSaved === 'function') {
                onSaved(this.items)

            }
            window.postMessage('cartSaved')
        })

    };
    getSeriesCartQnt = (series_id, product_id) => {
        let result = this.items.reduce((accumulator, el) => accumulator + (series_id === el.series_id && product_id === el.product_id ? el.quantity * 1 : 0), 0)
        return result > 0 ? result : ''
    }
    getSeriesCartId = (series_id, product_id) => {
        const result = this.items.find(el => series_id === el.series_id && product_id === el.product_id)

        return result ? result.id: undefined
    }

    getFirmFitCartQnt = () => {
        let result = this.items.reduce((accumulator, el) => accumulator + (el.is_firm_fit == '1' ? el.quantity * 1 : 0), 0)
        return result > 0 ? result : ''
    }
    getPrimaveraCartQnt = () => {
        let result = this.items.reduce((accumulator, el) => accumulator + (el.is_primavera == '1' ? el.quantity * 1 : 0), 0)
        return result > 0 ? result : ''
    }
    getBettaCartQnt = () => {
        let result = this.items.reduce((accumulator, el) => accumulator + (el.is_betta_ == '1' ? el.quantity * 1 : 0), 0)
        return result > 0 ? result : ''
    }
    getLQCartQnt = () => {
        let result = this.items.reduce((accumulator, el) => accumulator + (el.is_lq == '1' ? el.quantity * 1 : 0), 0)
        return result > 0 ? result : ''
    }
    getOffStockCartQnt = () => {
        let result = this.items.reduce((accumulator, el) => accumulator + (!el.sclad_id || el.sclad_id == -1 ? el.quantity * 1 : 0), 0)
        return result > 0 ? result : ''
    }
    getScladCartQnt = (sclad_id, product_id) => {
        let result = this.items.reduce((accumulator, el) => accumulator + (sclad_id === el.sclad_id && product_id === el.product_id ? el.quantity * 1 : 0), 0)
        return result > 0 ? result : ''
    }

    removeSeriaInCart = (series_id) => {
        this.items.map((el, i) => {
                if (el.series_id === series_id) {
                    this.items.splice(i, 1)
                }
            }
        )
    }
    getItems = (onLoad) => {
        let sAjaxSource = '/?app=cart&act=getItems&cart_id=' + this.getCartId()


        axios.get(this.base_url + sAjaxSource,
            {
                withCredentials: true
            }
        ).then((response) => {
 

            this.items = response.data;
            if (typeof onLoad === 'function') {
                onLoad(this.items)
                window.postMessage('cartUpdate')
            }

        })

    };

    getCartId = () => {
        let cart_id = localStorage.getItem(constants.CART_ID);

        if (cart_id == undefined) {
            cart_id = constants.getGUID();
            localStorage.setItem(constants.CART_ID, cart_id);
        }
        return cart_id;
    }


}

export default new CartApi(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod);
